import { evalCondition } from 'core/common/utils/evalCondition';
import { BaseConditionAttributes } from 'core/funnel/store/baseConditionAttributes';
import { emptyOffers, Offers } from '../entities';

export const resolveActiveOffers = (
  entries: Array<Offers>,
  attributes: BaseConditionAttributes,
): Offers => {
  const matchedEntry = entries.find(({ condition, feature }) => {
    if (!condition && !feature) {
      return false;
    }

    const isConditionMatched = !condition || !![attributes].find(evalCondition(condition));
    const isFeatureMatched = !feature || !![attributes].find(evalCondition(feature));

    return isConditionMatched && isFeatureMatched;
  });

  return matchedEntry ?? entries.at(-1) ?? emptyOffers;
};
